import React from 'react';

function ContactUsPage() {
    return <div>Contact Us Page</div>;
}

export default ContactUsPage;
